export default __webpack_public_path__ + "static/media/mobile-art-example.08b7f2eb.jpg";